import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16 2 .573-.82a1 1 0 0 0-1.146 0zM22.898 19.182a1 1 0 0 0-1.971-.34 4.99 4.99 0 0 1-4.082 4.072 1 1 0 1 0 .335 1.972 6.99 6.99 0 0 0 5.718-5.704"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16 2-.573-.82-.002.002-.002.001-.008.006-.025.018-.092.066q-.12.087-.335.25a33.516 33.516 0 0 0-4.718 4.445C7.688 8.91 5 13.14 5 18a11 11 0 1 0 22 0c0-4.86-2.688-9.09-5.245-12.031a33.5 33.5 0 0 0-3.545-3.497 29 29 0 0 0-1.508-1.199l-.092-.066-.025-.018-.008-.006-.002-.001-.002-.001zm-.915 1.996c.36-.305.671-.556.915-.746a31.535 31.535 0 0 1 4.245 4.031C22.688 10.091 25 13.861 25 18a9 9 0 0 1-18 0c0-4.14 2.312-7.91 4.755-10.719a31.5 31.5 0 0 1 3.33-3.285"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconDrop = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconDrop);
export default Memo;
